/**
 * Constants shared between frontend, admin, and (conceptually) backend.
 */

/** Base URL of the API worker. Can be overridden per environment. */
export const DEFAULT_API_BASE = 'https://hamster-api.goodluckfordev.workers.dev';

/** localStorage key where the active session token is kept. */
export const SESSION_TOKEN_KEY = 'xpb_session_token';

/** localStorage key hinting which account type the session belongs to. */
export const SESSION_TYPE_KEY = 'xpb_session_type';

export const CURRENCY_CODE_DEFAULT = 'MYR';
export const CURRENCY_SYMBOL_DEFAULT = 'RM';

export const SESSION_TTL_DAYS = 30;
export const EMAIL_CODE_TTL_MINUTES = 15;
